import cx from 'classnames';
const HomeArticles = ({ containerClass, articles }) => {
    console.log(articles, 'articles>>>');
    return (<div className={cx(containerClass)}>
      <h1 className="home-article-title-left">Welcome to Cherry Hills Village Code Enforcement</h1>
      {articles.map(({ article }) => (<article className="home-article" id={article.id}>
          <div dangerouslySetInnerHTML={{ __html: article.body }} className="home-article-info"/>
        </article>))}
    </div>);
};
export default HomeArticles;
